import { getTranslatedContentAsString } from 'libs/end-to-end/src/translation-content';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';
import React from 'react';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { TouchTargetProps } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import cn from 'classnames';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';

interface TertiaryButtonProps extends Pick<TouchTargetProps, 'behavior'> {
  label: TranslatedContent;
  icon?: React.ReactNode;
  className?: string;
  typographyClassName?: string;
  disabled?: boolean;
}

export const TertiaryButton: React.FC<TertiaryButtonProps> = (props) => {
  return (
    <TouchTarget
      {...props}
      label={getTranslatedContentAsString(props.label)}
      className="h-fit w-fit"
      disabled={props.disabled}
      content={({ hovered, disabled, focused }) => {
        const colorClass = cn({
          'text-royal-800': !hovered && !focused && !disabled,
          'text-royal-700': hovered && !disabled,
          'text-royal-900': focused && !disabled && !hovered,
          'text-gray-400': disabled,
        });

        return (
          <Spacing
            size="xs"
            direction="horizontal"
            className={cn(props.className, 'items-center', 'w-fit', colorClass)}
          >
            {props.icon}
            <S2Typography
              as="span"
              variant="headline-6-alt"
              translatedContent={props.label}
              textColorVariant="gray-1000"
              dangerouslyOverrideClassNameFn={(cn) =>
                `${cn.replace('text-gray-1000', colorClass)}${props.typographyClassName ? ' ' + props.typographyClassName : ''}`
              }
            />
          </Spacing>
        );
      }}
    />
  );
};
